import React from 'react';

import config, {Brand} from '../../../config';
import {getPriceCents, getPriceDollars} from '../../../utils/text';

import BmSnsBadge, {DEFAULT_BADGE_SIZE} from './BmSnsBadge';
import HbTcBadge from './HbTcBadge';
import {SvgBadgeComponent} from './types';

type BadgeProps = {
  price: string;
  text: string;
  size?: number;
};

const EmptyComponent = () => <></>;

export const Badge = ({price, text, size = DEFAULT_BADGE_SIZE}: BadgeProps) => {
  const brand = config.BASE_TENANT;
  let BadgeComponent: SvgBadgeComponent = EmptyComponent;

  switch (brand) {
    case Brand.BOTTLEMART:
    case Brand.SIPNSAVE:
      BadgeComponent = BmSnsBadge;
      break;
    case Brand.HARRY_BROWN:
    case Brand.THIRSTY_CAMEL:
      BadgeComponent = HbTcBadge;
      break;
    default:
      BadgeComponent = BmSnsBadge;
  }

  let priceDollars = '0';
  let priceCents = '00';

  if (price.includes('c')) {
    // 50c, 1c
    priceCents = price.replace('c', '');
    if (priceCents.length === 1) {
      priceCents = '0' + priceCents;
    }
  } else {
    // $12.50
    priceDollars = getPriceDollars(price);
    priceCents = getPriceCents(price);
  }

  return (
    <BadgeComponent
      price={price}
      priceDollars={priceDollars}
      priceCents={priceCents}
      text={text}
      size={size}
    />
  );
};
